<template>
  <div class="d2-layout-header-aside-group" :style="styleLayoutMainGroup" :class="{ grayMode: grayActive }">
    <!-- 半透明遮罩 -->
    <div class="d2-layout-header-aside-mask"></div>
    <!-- 主体内容 -->
    <div class="d2-layout-header-aside-content" flex="dir:top">
      <!-- 顶栏 -->
      <div class="d2-theme-header" :style="{
        opacity: this.searchActive ? 0.5 : 1
      }" flex-box="0" flex>
        <div class="logo-group"
             :style="{ width: asideCollapse ? asideWidthCollapse : (device === 'desktop' ? asideWidth : asideWidthCollapse) }"
             flex-box="0">
          <!-- <h3>{{asideCollapse}}</h3> -->
          <div v-if="device === 'desktop'">
            <img v-if="asideCollapse" style="width: 52px; height:26px" :src="require('@/assets/imgs/logo.png')">
            <img v-else style="width: 110px; height:45px" :src="require('@/assets/imgs/logo.png')">
          </div>
          <div v-else>
            <img style="width: 52px; height:26px" :src="require('@/assets/imgs/logo.png')">
          </div>
        </div>
        <div class="toggle-aside-btn" @click="handleToggleAside" flex-box="0">
          <d2-icon name="bars" />
        </div>
        <d2-menu-header flex-box="1" />
        <!-- 顶栏右侧 -->
        <div class="d2-header-right" flex-box="0" :class="{ 'd2-header-right-mobile': device === 'mobile' }">
          <!-- 如果你只想在开发环境显示这个按钮请添加 v-if="$env === 'development'" -->
          <!-- <d2-header-search @click="handleSearchClick"/>
          <d2-header-log/>
          <d2-header-fullscreen/> -->
          <!-- <d2-header-theme/>
          <d2-header-size/> -->
          <!-- <d2-header-fullscreen/> -->
          <d2-header-user />
        </div>
      </div>
      <!-- 下面 主体 -->
      <div class="d2-theme-container" flex-box="1" flex>

        <!-- 主体 侧边栏 -->
        <div flex-box="0" ref="aside" class="d2-theme-container-aside"
             :class="{ 'd2-theme-container-aside-mobile': device === 'mobile' }" :style="{
            width: asideCollapse ? (device === 'desktop' ? asideWidthCollapse : 0) : asideWidth,
            opacity: this.searchActive ? 0.5 : 1
          }">
          <d2-menu-side />
        </div>
        <!-- 主体 -->
        <div class="d2-theme-container-main" flex-box="1" flex @click="handleAutoClose">
          <!-- 搜索 -->

          <transition name="fade-scale">
            <div v-if="searchActive" class="d2-theme-container-main-layer" flex>
              <d2-panel-search ref="panelSearch" @close="searchPanelClose" />
            </div>
          </transition>
          <!-- 内容 -->
          <transition name="fade-scale">
            <div v-if="!searchActive" class="d2-theme-container-main-layer" flex="dir:top">
              <!-- tab -->
              <!-- <div class="d2-theme-container-main-header" flex-box="0">
                <d2-tabs/>
              </div> -->
              <!-- 页面 -->
              <div class="d2-theme-container-main-body" flex-box="1">
                <!--   标签页导航              -->
                <tags-view :isRouterAlive="isRouterAlive" @isRouterAlive="handleRouterAlive" />
                <transition :name="transitionActive ? 'fade-transverse' : ''">
                  <keep-alive v-if="isRouterAlive" :include="cachedViews" :key="keepAliveKey">
                    <router-view v-if="isRouterAlive" :key="$route.path" />
                  </keep-alive>
                </transition>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import d2MenuSide from './components/menu-side'
import d2MenuHeader from './components/menu-header'
import d2Tabs from './components/tabs'
// import d2HeaderFullscreen from './pricePropDetails/header-fullscreen'
// import d2HeaderSearch from './pricePropDetails/header-search'
// import d2HeaderSize from './pricePropDetails/header-size'
// import d2HeaderTheme from './pricePropDetails/header-theme'
import d2HeaderUser from './components/header-user'
// import d2HeaderLog from './pricePropDetails/header-log'
import { mapState, mapGetters, mapActions } from 'vuex'
import mixinSearch from './mixins/search'
import ResizeHandler from "@/layout/header-aside/mixins/ResizeHandler";
import TagsView from "@/layout/header-aside/components/TagsView/index.vue";
export default {
  name: 'd2-layout-header-aside',
  mixins: [
    mixinSearch,
    ResizeHandler
  ],
  components: {
    TagsView,
    d2MenuSide,
    d2MenuHeader,
    d2Tabs,
    // d2HeaderFullscreen,
    // d2HeaderSearch,
    // d2HeaderSize,
    // d2HeaderTheme,
    d2HeaderUser,
    // d2HeaderLog
  },
  data () {
    return {
      keepAliveKey:0,
      isRouterAlive: true,
      // [侧边栏宽度] 正常状态
      asideWidth: '200px',
      // [侧边栏宽度] 折叠状态
      asideWidthCollapse: '65px'
    }
  },
  watch: {
    // 监听 cachedViews 变化，强制重新渲染 keep-alive
    cachedViews: {
      handler(newVal, oldVal) {
        // 如果缓存列表变短了（有组件被删除），强制重新渲染
        if (newVal.length < oldVal.length) {
          this.keepAliveKey++
        }
      },
      deep: true
    }
  },
  computed: {
    cachedViews() {
      return this.$store.state.d2admin.tagsView.cachedViews
    },
    ...mapState('d2admin', {
      keepAlive: state => state.page.keepAlive,
      grayActive: state => state.gray.active,
      transitionActive: state => state.transition.active,
      asideCollapse: state => state.menu.asideCollapse,
      device: state => state.app.device
    }),
    ...mapGetters('d2admin', {
      themeActiveSetting: 'theme/activeSetting'
    }),
    /**
     * @description 最外层容器的背景图片样式
     */
    styleLayoutMainGroup () {
      return {
        ...this.themeActiveSetting.backgroundImage ? {
          backgroundImage: `url('${this.$baseUrl}${this.themeActiveSetting.backgroundImage}')`
        } : {}
      }
    }
  },
  methods: {
    handleRouterAlive (value) {
      this.isRouterAlive = value;
    },
    ...mapActions('d2admin/menu', [
      'asideCollapseToggle',
      'asideCollapseSet'
    ]),
    /**
     * 接收点击切换侧边栏的按钮
     */
    handleToggleAside () {
      this.asideCollapseToggle()
    },
    handleAutoClose () {
      if (this.device === 'mobile') {
        this.asideCollapseSet(true)
      }
    }
  }
}
</script>

<style lang="scss">
// 注册主题
@import '~@/assets/style/theme/register.scss';

.logo-group {
  background: #fff;
  // height: 5rem;
  box-shadow: 10px 0px 10px #ddd;
  display: flex;
  align-items: center;
  justify-content: center;
  // background: url('../../assets/imgs/logo.png') no-repeat;
  // background-size:60% 55%;
  // background-position:center;
}

.d2-layout-header-aside-group .d2-layout-header-aside-content .d2-theme-container .d2-theme-container-aside {
  z-index: 2;
}

.d2-layout-header-aside-group .d2-layout-header-aside-content .d2-theme-container .d2-theme-container-aside-mobile {
  position: absolute;
  top: 64px;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999999999 !important;
}

.d2-layout-header-aside-group .d2-layout-header-aside-content .d2-theme-header {
  height: 4rem;
  background: #F7F7F7;
  box-shadow: 10px 2px 10px #bbb;
  z-index: 1;
}

.d2-layout-header-aside-group .d2-layout-header-aside-content .d2-theme-header .d2-header-right {
  float: right;
  height: 4rem;
  width: 18rem;
  display: flex;
  justify-content: center;
}

.d2-theme-container-aside {
  background: #213763;
}

.theme-d2 .el-menu-item i,
.theme-d2 .el-submenu__title i:last-child {
  margin-right: 0px;
}

.theme-d2 .d2-theme-container .d2-theme-container-aside .el-menu .el-menu-item.is-active {
  color: #fff;
  fill: #fff;
  background: #0C234E;
}

.theme-d2 .d2-theme-container .d2-theme-container-aside .el-menu .el-menu-item.is-active i {
  color: #fff;
}

.el-dropdown {
  display: inline-block;
  position: relative;
  color: #606266;
  //font-size: 1vw;
}

.theme-container-aside .el-menu .el-menu-item i,
.el-menu-item {
  font-size: 0.8rem;
  height: 3.33rem;
  line-height: 3.33rem;
}

-menu-item,
.el-submenu__title {
  height: 3.33rem;
  line-height: 3.33rem;
  position: relative;
  -webkit-box-sizing: border-box;
  white-space: nowrap;
  list-style: none;
  //color: #fff !important;
  font-size: 0.8rem;
}

.el-submenu .el-menu-item {
  // 3.33rem;
  $height: 4.5rem;
  min-height: $height;
  line-height: $height;
  padding: 0;
}

.theme-d2 .d2-theme-container .d2-theme-container-aside .el-submenu .el-submenu__title i:first-child {
  margin-right: 4px;
}

.theme-d2 .d2-theme-container .d2-theme-container-aside .el-submenu .el-submenu__title i {
  color: #fff;

}

.theme-d2 .d2-theme-container .d2-theme-container-aside .el-submenu .el-submenu__title .el-submenu__icon-arrow {
  margin-top: -5px !important;
  color: #fff;
}

.d2-layout-header-aside-group .d2-layout-header-aside-content .d2-theme-container .d2-theme-container-aside .el-submenu .el-submenu__title i,
.d2-layout-header-aside-group .d2-layout-header-aside-content .d2-theme-container .d2-theme-container-aside .el-menu .el-menu-item i {
  width: 20px;
  text-align: center;
  font-size: 0.8rem;
}

.theme-d2 .d2-theme-container .d2-theme-container-aside .el-menu .el-menu-item {
  color: #fff;
  background: transparent;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.theme-d2 .d2-theme-container .d2-theme-container-aside .el-menu .el-menu-item i {
  color: #fff;
  margin-right: 4px;
}

.d2-layout-header-aside-group .d2-layout-header-aside-content .d2-theme-container .d2-theme-container-main .d2-theme-container-main-body {
  background: #F5F5F5;
  overflow-y: scroll;
}

.theme-d2 .el-menu-item span {
  word-break: break-word !important;
}
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/layout/header-aside/layout.vue"
}
</vue-filename-injector>
